import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { CommonTokenStorage } from './common-token-storage.service';

@Injectable({
  providedIn: 'root'
})
export class MapService {
  private mapLoaded$: Observable<boolean>;
  curLang: string;
  constructor(protected httpClient: HttpClient, protected tokenStorage: CommonTokenStorage) {
    this.curLang = this.tokenStorage.getCurrentLanguage();
    this.initMapLoading();
  }

  private initMapLoading(): void {
    this.mapLoaded$ = this.httpClient.jsonp(`https://maps.googleapis.com/maps/api/js?key=${window['map_api_key']}&libraries=places&language=${this.curLang}`, 'callback')
      .pipe(
        map(() => true),
        catchError(() => of(false)),
        shareReplay(1)
      );
  }

  getMapLoadedStatus(): Observable<boolean> {
    return this.mapLoaded$;
  }
  
  getCurrentCountryCoordinates(): Promise<{lat: number, lng: number}> {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve({
              lat: position.coords.latitude,
              lng: position.coords.longitude
            });
          },
          (error) => {
            console.error('Error getting location', error);
            reject(error);
          }
        );
      } else {
        console.error('Geolocation is not supported by this browser.');
        reject(new Error('Geolocation is not supported by this browser.'));
      }
    });
  }
}
